import type { LeagueSummary, Schemas } from "@softmax/observatory-client/types";
import { watchableLeagues } from "@softmax/web-features/leagues";
import { publicRead } from "@softmax/web-features/data/public-api";

async function publicLeagues({
  signal,
}: {
  signal?: AbortSignal | undefined;
}): Promise<LeagueSummary[]> {
  const leagues: LeagueSummary[] = [];
  let cursor: string | null = null;

  do {
    const params = new URLSearchParams({ limit: "50" });

    if (cursor !== null) params.set("cursor", cursor);

    let page = await publicRead<Schemas["LeagueCatalogPage"]>({
      path: `/v2/leagues/catalog?${params}`,
      signal,
    });

    if (page.oversized) {
      params.set("limit", "1");
      params.set("cacheable", "false");
      page = await publicRead<Schemas["LeagueCatalogPage"]>({
        path: `/v2/leagues/catalog?${params}`,
        signal,
      });
    }

    leagues.push(...page.leagues);
    cursor = page.next_cursor;
  } while (cursor !== null);

  return leagues;
}

export function watchLeagues({
  signal,
}: {
  signal?: AbortSignal | undefined;
} = {}): Promise<LeagueSummary[] | null> {
  return publicLeagues({ signal }).then(watchableLeagues, () => {
    signal?.throwIfAborted();
    return null;
  });
}
